"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(name) {
    return ['MODULE', 'UNLOAD', name];
}
exports.transformArguments = transformArguments;
